angular.module('mtic')
.service('FirebaseItematic', function(
  GLOBAL_API_CONFIG,
  $firebaseArray,
  $firebaseObject,
  $log
){
  var fbItematicApp;
  var getItemUrl;
  var syncCache = {};
  var storeItemUrlCache = function(groupId, groupItemId, releaseTag, url){
    syncCache[ [groupId, groupItemId, releaseTag].join('/') ] = url;
  }
  var getItemUrlCache = function(groupId, groupItemId, releaseTag){
    return syncCache[ [groupId, groupItemId, releaseTag].join('/') ];
  }

  //Init Firebase
  if(!GLOBAL_API_CONFIG.ITEMATIC.FIREBASE) {
    $log.warn("<<<<<<<<< Missing Firebase Configuration Data >>>>>>>>>")
  }
  else{
    fbItematicApp = firebase.initializeApp(GLOBAL_API_CONFIG.ITEMATIC.FIREBASE, String(Math.random().toString(36).substr(2,10) + Date.now()));
    var pathjoin = function(arr){ return '/'+arr.join('/')+'/'; }
    var getOnce = function(pathArr){
      var path = pathjoin(pathArr);
      return fbItematicApp.database().ref(path).once('value')
    }
    getItemUrl = function(groupId, groupItemId, releaseTag, cb){
      var errorUrl = GLOBAL_API_CONFIG.ITEMATIC.itemLoadErrorUrl
      return getOnce(['groups',groupId,'itemReleases', groupItemId, 'taggedReleases', releaseTag])
      .catch(function(e){
        $log.warn('could not load item release data');
        cb(errorUrl);
      })
      .then(function(data) {
        try{
          var itemReleaseId = data.val();
          getOnce(['groups',groupId,'itemReleases', groupItemId, 'releases', itemReleaseId]).
          then(function(data){
            var itemReleaseData = data.val();
            var release = itemReleaseData;
            if (!release){
              throw new Error();
            }
            var engineBaseURL = GLOBAL_API_CONFIG.ITEMATIC.engineBaseURL
            var engineVersion = release.engineVersion;
            var rootComponent = release.rootComponent;
            var itemVersionId = release.itemVersionId;
            var url = engineBaseURL + '/v' + engineVersion +'/' + rootComponent + '/index.html#!/'+rootComponent+'/'+itemVersionId;
            storeItemUrlCache(groupId, groupItemId, releaseTag, url);
            cb(url);
          }).catch(function(e){
            $log.warn('could not find matching item release');
            cb(errorUrl);
          })

        }
        catch(e){
          $log.warn('no item release data is defined in Itematic', groupId, groupItemId, releaseTag);
          cb(errorUrl);
        }
        // return data;
      });
    }
    // setTimeout(function(){
    //   getItemUrl('LUX_GR78', '-KwaizxHR_Jw56Cnm7Nn', GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.QC, function(url){
    //     console.log('ITEM URL:', url);
    //   });
    // }, 1000)
  }
  return {
    getItemUrl: getItemUrl,
    getReleaseTagByQcStatus: function(options){
      if (options){
        if (options.isQC){
          return GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.QC;
        }
        if (options.isPrelive){
          return GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.PRELIVE;
        }
      }
      return GLOBAL_API_CONFIG.ITEMATIC.RELEASE_TAGS.LIVE;
    }
  }
})
